export enum EngageObjectType {
	HTML5 = 1,
	Blog = 2,
	MediabankFile = 3,
	SCORM = 4,
	Speedquiz = 5,
	Certification = 6,
	Mission = 7,
}

export enum EngageObjectUserStatus {
	NotStarted = -1,
	Started = 1,
	Cancelled = 2,
	Finished = 3,
	Resumed = 4,
}
